import {
  formatCurrency,
  formatParentTaskId,
  formatHour,
  capitalize,
  TicketEscalation,
  formatIsoDate,
  formatUSDate,
  convertDateFormat,
  formatPhoneNumber,
  formattedDate,
  toLocalDateTime,
  renderLink,
} from "./grid-value-formatters";
import PageLink from "../component/PageLink";
import Button from "@mui/material/Button";
import { Box } from "@material-ui/core";
import { useState } from "react";
import createDateAsUTC from "../pages/hrm/appraisal/employeeAppraisal/appraisal.list";
export const userProjectTable = [
  // { headerName: "Id", field: "project_id", maxWidth: 80, resizable: true,cellStyle: {fontSize: '11px'} },
  {
    headerName: "Project Name",
    field: "project_name",
    tooltipField: "project_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
    // cellRenderer: (param) => (
    //   <PageLink
    //     params={{ ...param, value: capitalize(param) }}
    //     grab="project_id"
    //     path="/projects/"
    //   />
    // ),
  },
  {
    headerName: "Project Manager",
    field: "project_manager",
    tooltipField: "project_manager",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 70,
  },
  // {
  //   headerName: "Role",
  //   field: "project_role",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  //   minWidth: 70,
  // },
  {
    headerName: "Type",
    field: "project_type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    headerClass: "justify-center",
    cellClass: "pmt-ag-cell-font justify-center",
    minWidth: 70,
  },
  {
    headerName: "Start Date",
    field: "start_date",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatUSDate,
    minWidth: 120,
  },
  {
    headerName: "End Date",
    field: "end_date",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatUSDate,
    minWidth: 120,
  },
  {
    headerName: "Status",
    field: "status",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    headerClass: "justify-center",
    cellClass: "pmt-ag-cell-font justify-center",
    minWidth: 100,
  },
  {
    headerName: "Created At",
    field: "creation_date",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    valueFormatter: formatUSDate,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 100,
  },
];

export const ticketsTable = [
  {
    headerName: "Ticket Id",
    field: "ticketid",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
    cellRenderer: (params) => <PageLink params={params} />,
  },
  {
    headerName: "Ticket Escalation",
    field: "escalate",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 130,
    valueFormatter: TicketEscalation,
  },
  {
    headerName: "Type",
    field: "type",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 70,
  },
  {
    headerName: "Severity",
    field: "severity",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 80,
  },
  {
    headerName: "Subject",
    field: "problem",
    tooltipField: "problem",
    minWidth: 120,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Status",
    field: "status",
    minWidth: 120,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Customer",
    field: "company_name",
    cellClass: "pmt-ag-cell-font",
    minWidth: 110,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Assigned To",
    field: "assigned",
    cellClass: "pmt-ag-cell-font capitalizeNone",
    tooltipField: "assigned",
    minWidth: 150,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Created By",
    field: "created_by",
    tooltipField: "created_by",
    minWidth: 150,
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },

  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right text-right",
    minWidth: 110,
  },
  // {
  //   headerName: "Ticket",
  //   field: "flag",
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  //   minWidth: 100,
  //   valueFormatter: TicketFormatter,
  // },
];
export const CustomerticketsTable = [
  {
    headerName: "Ticket Id",
    field: "ticketid",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
    // cellRenderer: (params) => <PageLink params={params} />,
  },
  {
    headerName: "Ticket Escalation",
    field: "escalate",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 130,
    valueFormatter: TicketEscalation,
  },
  {
    headerName: "Type",
    field: "type",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 70,
  },
  {
    headerName: "Severity",
    field: "severity",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 80,
  },
  {
    headerName: "Subject",
    field: "problem",
    tooltipField: "problem",
    minWidth: 80,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Status",
    field: "status",
    minWidth: 100,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Customer",
    field: "firstname",
    minWidth: 90,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Assigned To",
    field: "assigned",
    minWidth: 100,
    resizable: true,
    tooltipField: "assigned",
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Created By",
    field: "created_by",
    tooltipField: "created_by",
    minWidth: 100,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right text-right",
    minWidth: 110,
  },
];
export const reportsTable = [
  {
    headerName: "Ticket Id",
    field: "ticketid",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    //autoSizeColumn,
    minWidth: 90,
  },
  {
    headerName: "Type",
    field: "type",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
  },
  {
    headerName: "Severity",
    field: "severity",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 80,
  },
  {
    headerName: "Subject",
    field: "problem",
    tooltipField: "problem",
    minWidth: 120,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Status",
    field: "status",
    minWidth: 120,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Customer",
    field: "company_name",
    minWidth: 110,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Assigned To",
    field: "assigned",
    minWidth: 140,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    tooltipField: "assigned",
  },
  {
    headerName: "Created By",
    field: "created_by",
    tooltipField: "created_by",
    minWidth: 140,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    tooltipField: "created_by",
  },
  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right text-right",
    minWidth: 110,
  },
  // {
  //   headerName: "Ticket",
  //   field: "flag",
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  //   minWidth: 150,
  //   valueFormatter: TicketFormatter,
  // },
];
export const employeesTable = [
  {
    headerName: "Resource Id",
    field: "employeeid",
    resizable: true,
    cellStyle: { fontSize: "11px" },
    minWidth: 80,
    maxWidth: 100,
  },
  {
    headerName: "First Name",
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: { fontSize: "11px", color: "#007bff", lineHeight: "18px" },
    minWidth: 80,
    maxWidth: 100,
    cellRenderer: (param) => (
      <PageLink params={{ ...param, value: capitalize(param) }} />
    ),
  },
  {
    headerName: "Last Name",
    field: "lastname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    valueFormatter: capitalize,
    minWidth: 80,
    maxWidth: 100,
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    minWidth: 120,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },

  // {
  //   headerName: "Contact",
  //   field: "contact",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellStyle: { fontSize: "11px", lineHeight: "18px" },
  // },
  // {
  //   headerName: "Address",
  //   field: "address",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellStyle: { fontSize: "11px", lineHeight: "16px" },
  // },

  {
    headerName: "Role",
    field: "role",
    valueFormatter: capitalize,
    minWidth: 80,
    maxWidth: 90,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    tooltipField: "role",
  },
  // {
  //   headerName: "Cost Rate",
  //   field: "cost_rate",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  //   valueFormatter: formatCurrency,
  // },
  // {
  //   headerName: "Bill Rate",
  //   field: "bill_rate",
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  //   minWidth: 150,
  //   valueFormatter: formatCurrency,
  // },
  {
    headerName: "Department",
    field: "department",
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
    maxWidth: 150,
  },
  {
    headerName: "Reporting Manager",
    field: "reportingmanager",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 150,
    tooltipField: "reportingmanager",
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 90,
    maxWidth: 100,
  },
];
export const employeesticketsTable = [
  {
    headerName: "Ticket Id",
    field: "ticketid",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 90,
  },
  {
    headerName: "Ticket Escalation",
    field: "escalate",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 130,
    valueFormatter: TicketEscalation,
  },
  {
    headerName: "Type",
    field: "type",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 70,
  },
  {
    headerName: "Severity",
    field: "severity",
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 80,
  },
  {
    headerName: "Subject",
    field: "problem",
    tooltipField: "problem",
    minWidth: 120,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Status",
    field: "status",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Customer",
    field: "firstname",
    minWidth: 110,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Assigned To",
    field: "assigned",
    minWidth: 150,
    resizable: true,
    tooltipField: "assigned",
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Created By",
    field: "created_by",
    tooltipField: "created_by",
    minWidth: 150,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },

  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right text-right",
    minWidth: 110,
  },
  // {
  //   headerName: "Ticket",
  //   field: "flag",
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  //   minWidth: 100,
  //   valueFormatter: TicketFormatter,
  // },
];
export const ticketsUpdateTable = [
  {
    headerName: "Comment Text",
    field: "comment_text",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Comment Date",
    field: "comment_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 100,
  },
  {
    headerName: "Added By",
    field: "email",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    tooltipField: "email",
  },
  // { headerName: "Action", field: "actions", resizable: true,cellStyle: {fontSize: '11px'} },
];
export const ticketsAttachmentTable = [
  {
    headerName: "Mime Type",
    field: "mime_type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Created By",
    field: "created_by",
    tooltipField: "created_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right text-right",
    minWidth: 110,
  },
];
export const ticketsAuditTable = [
  {
    headerName: "Column Name",
    field: "column_name",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Old Value",
    field: "old_value",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "New Value",
    field: "new_value",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Changed By",
    field: "changed_by",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Changed Date",
    field: "changed_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right text-right",
  },
];

export const customerTable = [
  {
    headerName: "Company Name",
    field: "company_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
    cellRenderer: (param) => (
      <PageLink params={{ ...param, value: capitalize(param) }} />
    ),
  },
  {
    headerName: "Primary Contact",
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
    cellRenderer: (param) => (
      <PageLink params={{ ...param, value: capitalize(param) }} />
    ),
  },
  // {
  //   headerName: "Last Name",
  //   valueFormatter: capitalize,
  //   field: "lastname",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font",
  //   minWidth: 100,
  // },
  {
    headerName: "Primary Email",
    field: "email",
    tooltipField: "email",
    minWidth: 200,
    maxWidth: 400,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Phone Number",
    field: "contact",
    minWidth: 110,
    maxWidth: 150,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    valueFormatter: formatPhoneNumber,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Address",
    field: "address",
    tooltipField: "address",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 100,
  },
];
export const subCustomerTable = [
  // { headerName: 'Id', field: 'id', resizable: true,cellStyle: {fontSize: '11px'}, maxWidth: 80 },
  {
    headerName: "First Name",
    valueFormatter: capitalize,
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
    maxWidth: 150,
    cellRenderer: (param) => (
      <PageLink params={{ ...param, value: capitalize(param) }} />
    ),
  },
  {
    headerName: "Last Name",
    valueFormatter: capitalize,
    field: "lastname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
    maxWidth: 150,
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    minWidth: 100,
    maxWidth: 300,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Contact",
    field: "contact",
    minWidth: 90,
    maxWidth: 150,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Address",
    field: "address",
    tooltipField: "address",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 80,
    maxWidth: 130,
  },
];

export const projectsTable = [
  // { headerName: 'Id', field: 'id', resizable: true,cellStyle: {fontSize: '11px'}, maxWidth: 80 },
  {
    headerName: "Project Name",
    field: "project_name",
    tooltipField: "project_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 170,
    cellRenderer: (params) => <PageLink params={params} />,
  },
  {
    headerName: "Type",
    field: "project_type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 70,
    maxWidth: 80,
  },
  // {
  //   headerName: "Description",
  //   field: "project_description",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  // },
  {
    headerName: "Project Manager",
    field: "project_manager",
    tooltipField: "project_manager",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 160,
  },
  {
    headerName: "Customer",
    field: "customer_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 90,
    tooltipField: "customer",
  },
  {
    headerName: "Budget",
    field: "budget",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatCurrency,
  },
  {
    headerName: "Start Date",
    field: "start_date",
    valueFormatter: formatUSDate,
    minWidth: 90,
    maxWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "End Date",
    field: "end_date",
    valueFormatter: formatUSDate,
    minWidth: 90,
    maxWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Status",
    field: "status",
    minWidth: 80,
    maxWidth: 90,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    headerClass: "justify-center",
    cellClass: "pmt-ag-cell-font justify-center",
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 90,
    maxWidth: 100,
  },
];

export const purchaseTable = [
  {
    headerName: "PO Number",
    field: "po_number",
  
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    //cellRenderer: (params) => <PageLink params={params} />,
  },
  //   {
  //   headerName: "PO Vendor Name",
  //   field: "po_vendor_name",
 
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   //cellRenderer: (params) => <PageLink params={params} />,
  // },
   {
    headerName: "Vendor Name",
    field: "vendor_name",

    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    //cellRenderer: (params) => <PageLink params={params} />,
  },
  
  {
    headerName: "Project Name",
    field: "project_name",
    // valueFormatter: formatUSDate,

    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Shipping Date",
    field: "shipping_date",
    
    // valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Total Amount",
    field: "total_amount",
    tooltipField: "total_amount",
  
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Approval Status",
    field: "approval_status",
 
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    // valueFormatter: formatCurrency,
  },
  
  // {
  //   headerName: "Project Id",
  //   field: "project_id",
  //   minWidth: 100,
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  // },
  // {
  //   headerName: "Vendor Id",
  //   field: "vendor_id",
  //   minWidth: 100,
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  // },
  {
    headerName: "Created Date",
    field: "created_date",
    // valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",

  },
];

export const purchaseTableForProject = [
  {
    headerName: "PO Number",
    field: "po_number",
    minWidth: 120,
    resizable: true,
    cellRenderer: (params) => <PageLink params={params} />,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Project Name",
    field: "project_name",
    minWidth: 110,
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Vendor",
    field: "vendor_name",
    minWidth: 110,
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  // {
  //   headerName: "Shipping Date",
  //   field: "shipping_date",
  //   valueFormatter: formatUSDate,
  //   minWidth: 110,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
  //   headerClass: "justify-right",
  // },
  {
    headerName: "Total Amount",
    field: "po_amount",
    tooltipField: "po_amount",
    minWidth: 120,
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  // {
  //   headerName: "Discount Terms",
  //   field: "discount_terms",
  //   minWidth: 110,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
  //   headerClass: "justify-right",
  // },
  // {
  //   headerName: "FOB Instruction",
  //   field: "fob_instruction",
  //   minWidth: 110,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
  //   headerClass: "justify-right",
  // },
  // {
  //   headerName: "Bill Count",
  //   field: "bill_count",
  //   minWidth: 110,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
  //   headerClass: "justify-right",
  // },
  // {
  //   headerName: "Item Receipt Count",
  //   field: "item_receipt_count",
  //   minWidth: 110,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
  //   headerClass: "justify-right",
  // },

  {
    headerName: "Status",
    field: "status",
    minWidth: 120,
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: " Approval Status",
    field: "approval_status",
    tooltipField: "approval_status",
    minWidth: 140,
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 110,
  },
];

export const assetTable = [
  // {
  //   headerName: "Asset Id",
  //   field: "asset_id",
  //   resizable: true,
  //   minWidth: 100,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font font-blue justify-right",
  //   headerClass: "justify-right",
  //   cellRenderer: (params) => (
  //     <Button sx={{ height: "20px", px: 1 }} variant="outlined">
  //       <PageLink params={params} />
  //     </Button>
  //   ),
  // },
  {
    headerName: "Item Name",
    field: "item_name",
    minWidth: 100,
    cellClass: "pmt-ag-cell-font capitalize",
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },

  {
    headerName: "Manufacturer",
    field: "manufacturer",
    minWidth: 120,
    cellClass: "pmt-ag-cell-font capitalize",
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  // {
  //   headerName: "Description",
  //   field: "description",
  //   tooltipField: "description",
  //   minWidth: 170,
  //   cellClass: "pmt-ag-cell-font capitalize",
  //   wrapText: true,
  //   autoHeight: true,
  //   resizable: true,
  // },
  {
    headerName: "Model",
    field: "model",
    minWidth: 100,
    cellClass: "pmt-ag-cell-font capitalize",
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Serial Number",
    field: "serialnumber",
    minWidth: 120,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Operating system",
    field: "operatingsystem",
    minWidth: 140,
    cellClass: "pmt-ag-cell-font capitalize",
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "CPU",
    field: "cpu",
    minWidth: 100,
    cellClass: "pmt-ag-cell-font capitalize",
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Unit Cost($)",
    field: "unitcost",
    minWidth: 100,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  // {
  //   headerName: "Status",
  //   field: "status",
  //   minWidth: 100,
  //   autoHeight: true,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font",
  // },
  {
    headerName: "Location",
    field: "location",
    minWidth: 100,
    cellClass: "pmt-ag-cell-font capitalize",
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Purchased Date",
    field: "purchasedate",
    minWidth: 120,
    cellClass: "pmt-ag-cell-font",

    wrapText: true,
    autoHeight: true,
    resizable: true,
    valueFormatter: formatUSDate,
  },
  {
    headerName: "Warranty Expiration Date",
    field: "warrantyexpirationdate",
    minWidth: 190,
    cellClass: "pmt-ag-cell-font",

    valueFormatter: formatUSDate,
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Created By",
    field: "created_by",
    tooltipField: "created_by",
    minWidth: 140,
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Created At",
    field: "created_date",
    minWidth: 100,
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  // {
  //   headerName: "MAC Address",
  //   field: "macaddress",
  //   minWidth: 120,
  //   cellClass: "pmt-ag-cell-font capitalize",
  //   wrapText: true,
  //   autoHeight: true,
  //   resizable: true,
  // },
  // {
  //   headerName: "IMEI",
  //   field: "imei",
  //   minWidth: 100,
  //   cellClass: "pmt-ag-cell-font capitalize",
  //   wrapText: true,
  //   autoHeight: true,
  //   resizable: true,
  // },

  // {
  //   headerName: "Asset Image",
  //   field: "assetimage",

  //   minWidth: 100,
  //   autoHeight: true,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font",
  // },
];

export const assetNotesTable = [
  // {
  //   headerName: "Asset Id",
  //   field: "asset_id",
  //   minWidth: 100,
  //   autoHeight: true,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font",
  // },
  {
    headerName: "Note",
    field: "note",
    tooltipField: "note",
    minWidth: 100,
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Created By",
    field: "created_by",
    tooltipField: "created_by",
    minWidth: 100,
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Created At",
    field: "created_at",
    minWidth: 100,
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
    valueFormatter: formatUSDate,
  },
];

export const assetAuditsTable = [
  {
    headerName: "Asset Id",
    field: "asset_id",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Column Name",
    field: "column_name",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Old Value",
    field: "old_value",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "New Value",
    field: "new_value",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Changed By",
    field: "changed_by",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Changed Date",
    field: "changed_date",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
    valueFormatter: formatUSDate,
  },
];

export const categoryTable = [
  {
    headerName: "Category",
    field: "category",
    resizable: true,
    cellClass: "pmt-ag-cell-font font-blue",
    cellRenderer: (params) => <PageLink params={params} />,
  },
  {
    headerName: "Description",
    field: "description",
    tooltipField: "description",
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Created Date",
    valueFormatter: formatUSDate,
    field: "created_date",
    resizable: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right text-right",
  },
];

export const vendorTable = [
  {
    headerName: "Vendor Name",
    field: "vendor_name",
    minWidth: 120,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    cellRenderer: (param) => (
      <PageLink params={{ ...param, value: capitalize(param) }} />
    ),
  },
  {
    headerName: "Company Name",
    field: "company_name",
    tooltipField: "company_name",
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 130,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Email",
    field: "email",
    minWidth: 100,
    tooltipField: "email",
    cellClass: "pmt-ag-cell-font capitalizeNone",
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Contact",
    field: "contact",
    minWidth: 100,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Postal Code",
    field: "postal_code",
    minWidth: 100,
    resizable: true,
    autoHeight: true,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
  },
  {
    headerName: "City",
    field: "city",
    minWidth: 100,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "State",
    field: "state",
    minWidth: 100,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Country",
    field: "country",
    minWidth: 100,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Currency",
    field: "currency",
    minWidth: 100,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Billing Address",
    field: "billing_address",
    minWidth: 120,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Shipping Address",
    field: "shipping_address",
    tooltipField: "shipping_address",
    minWidth: 140,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 100,
  },
];

export const taskTable = [
  {
    headerName: "Code",
    field: "task_code",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Task Name",
    field: "task_name",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Description",
    field: "task_description",
    tooltipField: "task_description",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Status",
    field: "status",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Parent Task",
    field: "parent_task_id",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    valueFormatter: formatParentTaskId,
    cellClass: "",
  },
  {
    headerName: "Budget",
    field: "budget",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatCurrency,
  },
  {
    headerName: "Start Date",
    field: "start_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "End Date",
    field: "end_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    cwrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 100,
  },
];

// ep.project_role, ep.creation_date, e.firstname, e.lastname, e.contact, e.email, e.id
export const projectEmployeesTable = [
  {
    headerName: "Task Code",
    field: "task_code",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: { fontSize: "11px", lineHeight: "20px" },
  },
  {
    headerName: "Task",
    field: "task_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: { fontSize: "11px", lineHeight: "20px" },
  },
  {
    headerName: "Employee",
    valueFormatter: capitalize,
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },

  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    cellClass: "pmt-ag-cell-font capitalizeNone",
    //wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,

    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
];

export const projectTaskTable = [
  {
    headerName: "Task Code",
    field: "task_code",
    minWidth: 100,
    needsTooltip: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Name",
    field: "task_name",
    minWidth: 100,
    needsTooltip: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  // {
  //   headerName: "Description",
  //   field: "task_description",
  //   minWidth: 100,
  //   needsTooltip: true,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  // },
  // {
  //   headerName: "Budget",
  //   field: "budget",
  //   minWidth: 80,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  //   valueFormatter: (v) => "$" + new Intl.NumberFormat("en-US").format(v),
  //   cellClass: "capitalizeNone",
  // },
  // {
  //   headerName: "Actual",
  //   field: "actual",
  //   minWidth: 80,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  // },

  {
    headerName: "Start Date",
    field: "start_date",
    minWidth: 100,
    valueFormatter: convertDateFormat,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "End Date",
    field: "end_date",
    minWidth: 100,
    valueFormatter: convertDateFormat,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  // { headerName: "Created At", field: "creation_date", minWidth: 150, valueFormatter: formatCustomDate },
  {
    headerName: "Status",
    field: "status",
    minWidth: 100,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "% Complete",
    field: "percent_complete",
    minWidth: 100,
    valueFormatter: (value) => parseFloat(value).toFixed(2),
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
];

export const workerProjectTaskTable = [
  {
    headerName: "Task Code",
    field: "task_code",
    minWidth: 100,
    needsTooltip: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Task Name",
    field: "task_name",
    minWidth: 100,
    needsTooltip: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Description",
    field: "task_description",
    tooltipField: "task_description",
    minWidth: 100,
    needsTooltip: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Complete %",
    field: "percent_complete",
    minWidth: 100,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Start Date",
    field: "start_date",
    minWidth: 100,
    valueFormatter: formatUSDate,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "End Date",
    field: "end_date",
    minWidth: 100,
    valueFormatter: formatUSDate,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  // { headerName: "Created At", field: "creation_date", minWidth: 150, valueFormatter: formatCustomDate },
  {
    headerName: "Status",
    field: "status",
    minWidth: 100,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
];

export const employeeTimesheetTable = [
  // { headerName: "Task Id", field: "task_id", minWidth: 80, maxWidth: 100, resizable: true,cellStyle: {fontSize: '11px'} },
  {
    headerName: "Project",
    field: "project_name",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Task",
    field: "task_name",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Week Start",
    field: "week_start_date",
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    valueFormatter: formatUSDate,
    minWidth: 110,
  },
  {
    headerName: "Week End",
    field: "week_end_date",
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
    wrapText: true,
    autoHeight: true,
    resizable: true,
    minWidth: 80,
    valueFormatter: formatUSDate,
  },
  {
    headerName: "Timesheet Status",
    field: "approvalstatus",
    cellClass: "pmt-ag-cell-font",
    minwidth: 150,
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Monday",
    field: "monday_hours",
    minwidth: 70,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Monday Notes",
    field: "mon_notes",
    minwidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Tuesday",
    field: "tuesday_hours",
    minwidth: 70,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    valueFormatter: formatHour,
    resizable: true,
    wrapText: true,
    autoHeight: true,
  },
  {
    headerName: "Tuesday Notes",
    field: "tue_notes",
    minwidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Wednesday",
    field: "wednesday_hours",
    minwidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Wednesday Notes",
    field: "wed_notes",
    minwidth: 150,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Thursday",
    field: "thursday_hours",
    minwidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Thursday Notes",
    field: "thu_notes",
    minwidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Friday",
    field: "friday_hours",
    minwidth: 60,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Friday Notes",
    field: "fri_notes",
    minwidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Saturday",
    field: "saturday_hours",
    minwidth: 70,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Saturday Notes",
    field: "sat_notes",
    minwidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Sunday",
    field: "sunday_hours",
    minwidth: 60,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Sunday Notes",
    field: "sun_notes",
    minwidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },

  {
    headerName: "Approve/Reject Note",
    field: "approvalstatuscomment",
    minWidth: 150,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
];

export const projectTimesheetTable = [
  {
    headerName: "Task",
    field: "task_name",
    minWidth: 110,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Resource",
    field: "employee_name",
    minWidth: 150,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Week Start",
    field: "week_start_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Week End",
    field: "week_end_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Timesheet Status",
    field: "approvalstatus",
    minWidth: 150,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Monday",
    field: "monday_hours",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Monday Notes",
    field: "mon_notes",
    minWidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Tuesday",
    field: "tuesday_hours",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Tuesday Notes",
    field: "tue_notes",
    minWidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Wednesday",
    field: "wednesday_hours",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Wednesday Notes",
    field: "wed_notes",
    minWidth: 150,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Thursday",
    field: "thursday_hours",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Thursday Notes",
    field: "thu_notes",
    minWidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Friday",
    field: "friday_hours",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Friday Notes",
    field: "fri_notes",
    minWidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Saturday",
    field: "saturday_hours",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Saturday Notes",
    field: "sat_notes",
    minWidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Sunday",
    field: "sunday_hours",
    minWidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatHour,
  },
  {
    headerName: "Sunday Notes",
    field: "sun_notes",
    minWidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },

  {
    headerName: "Approve/Reject Note",
    field: "approvalstatuscomment",
    minWidth: 150,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
];

export const employeeProjectsTable = [
  // { headerName: 'Id', field: 'id', resizable: true,cellStyle: {fontSize: '11px'}, maxWidth: 80 },
  {
    headerName: "Name",
    field: "project_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    // minWidth: 100,
    maxWidth: 300,
  },
  // {
  //   headerName: "Role",
  //   field: "project_role",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  //   minWidth: 100,
  // },

  // {
  //   headerName: "Type",
  //   field: "project_type",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  //   minWidth: 70,
  // },
  // {
  //   headerName: "Description",
  //   field: "project_description",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  // },
  // {
  //   headerName: "Budget",
  //   field: "budget",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //  cellClass: "pmt-ag-cell-font"
  //   valueFormatter: formatCurrency,
  //   cellClass: "capitalizeNone",
  // },
  {
    headerName: "Start Date",
    field: "project_start",
    valueFormatter: formatUSDate,
    minWidth: 80,
    maxWidth: 200,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "End Date",
    field: "project_end",
    valueFormatter: formatUSDate,
    minWidth: 80,
    maxWidth: 200,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Status",
    field: "status",
    minWidth: 80,
    maxWidth: 190,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Customer",
    field: "customer_email",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 100,
    tooltipField: "customer_email",
  },
  {
    headerName: "Created At",
    field: "assigning_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 100,
  },
  // { headerName: "Created At", field: "creation_date", resizable: true,cellStyle: {fontSize: '11px'}, minWidth: 150, valueFormatter: formatDate }
];

export const vendorPurchaseTable = [
  {
    headerName: "PO Number",
    field: "po_number",
    minWidth: 100,
    maxWidth: 140,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    cellRenderer: (params) => (
      <PageLink params={params} path="/purchase-orders/" />
    ),
  },
  {
    headerName: "Order Date",
    field: "po_date",
    valueFormatter: formatUSDate,
    minWidth: 80,
    maxWidth: 90,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Delivery Date",
    field: "delivery_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    maxWidth: 110,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Description",
    field: "po_description",
    tooltipField: "po_description",
    minWidth: 170,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Amount",
    field: "po_amount",
    minWidth: 80,
    maxWidth: 100,
    cellClass: "pmt-ag-cell-font  justify-right",
    headerClass: "justify-right",
    resizable: true,
    autoHeight: true,
    valueFormatter: formatCurrency,
  },
  {
    headerName: "Terms",
    field: "payment_terms",
    minWidth: 80,
    maxWidth: 100,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Shipping Address",
    field: "shipping_address",
    tooltipField: "shipping_address",
    minWidth: 140,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Project Id",
    field: "project_id",
    resizable: true,
    autoHeight: true,
    minWidth: 70,
    maxWidth: 80,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Vendor Id",
    field: "vendor_id",
    resizable: true,
    autoHeight: true,
    minWidth: 80,
    maxWidth: 90,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 90,
    maxWidth: 100,
  },
];

export const orderItemsTable = [
  {
    headerName: "Name",
    field: "item_name",
    minwidth: 80,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Description",
    field: "item_description",
    tooltipField: "item_description",
    minwidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Price($)",
    field: "item_price",
    minwidth: 70,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    valueFormatter: formatCurrency,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Quantity",
    field: "quantity",
    minwidth: 70,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Discount(%)",
    field: "discount_percentage",
    minwidth: 90,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Tax(%)",
    field: "tax_percentage",
    minwidth: 70,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Net Cost($)",
    field: "net_cost",
    minwidth: 90,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Task",
    field: "task_name",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Task Code",
    field: "task_code",
    minwidth: 90,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
];

export const customerProjectsTable = [
  // { headerName: 'Id', field: 'id', resizable: true,cellStyle: {fontSize: '11px'}, maxWidth: 80 },
  {
    headerName: "Project Name",
    field: "project_name",
    tooltipField: "project_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
  },
  {
    headerName: "Type",
    field: "project_type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 70,
  },
  {
    headerName: "Description",
    field: "project_description",
    tooltipField: "project_description",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Budget",
    field: "budget",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatCurrency,
  },
  {
    headerName: "Start Date",
    field: "start_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "End Date",
    field: "end_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Status",
    field: "status",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Creation Date",
    field: "creation_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  // { headerName: "Created At", field: "creation_date", resizable: true,cellStyle: {fontSize: '11px'}, minWidth: 150, valueFormatter: formatDate }
];

export const projectActivitiesTable = [
  {
    headerName: "Task Code",
    field: "task_code",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 100,
  },
  {
    headerName: "Task",
    field: "task_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 150,
    valueFormatter: capitalize,
  },
  {
    headerName: "Activity Name",
    field: "activity_name",
    tooltipField: "activity_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 160,
    valueFormatter: capitalize,
  },
  {
    headerName: "Description",
    field: "description",
    tooltipField: "description",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 140,
    valueFormatter: capitalize,
    // maxWidth: 200,
  },
  {
    headerName: "Resource",
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
    tooltipField: "email",
  },

  {
    headerName: "% Complete",
    field: "percent_complete",
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right capitalizeNone",
    resizable: true,
    wrapText: true,
    autoHeight: true,

    minWidth: 100,
  },
  {
    headerName: "Start Date",
    field: "start_date",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatUSDate,
    minWidth: 110,
  },
  {
    headerName: "End Date",
    field: "end_date",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    valueFormatter: formatUSDate,
    minWidth: 110,
  },
];
export const projectReccuringActivitiesTable = [
  {
    headerName: "Task Code",
    field: "task_code",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 110,
  },
  {
    headerName: "Task",
    field: "task_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 150,
  },
  {
    headerName: "Activity Name",
    field: "activity_name",
    tooltipField: "activity_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 160,
  },
  {
    headerName: "Description",
    field: "description",
    tooltipField: "description",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 120,
    // maxWidth: 200,
  },
  {
    headerName: "Employee",
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 100,
    tooltipField: "email",
  },

  {
    headerName: "% Complete",
    field: "percent_complete",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right capitalizeNone",
    minWidth: 110,
  },
  {
    headerName: "Recurring Frequency",
    field: "recurring_frequency",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 160,
  },
  // {
  //   headerName: "End Date",
  //   field: "end_date",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   valueFormatter: formatUSDate,
  //   // maxWidth: 110,
  // },
];

export const subCustomerListTable = [
  // { headerName: 'Id', field: 'id', resizable: true,cellStyle: {fontSize: '11px'}, maxWidth: 80 },
  {
    headerName: "First Name",
    valueFormatter: capitalize,
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
    // cellRenderer: (param) => (
    //   <PageLink params={{ ...param, value: capitalize(param) }} />
    // ),
  },
  {
    headerName: "Last Name",
    valueFormatter: capitalize,
    field: "lastname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 100,
    wrapText: true,
    autoHeight: true,
    resizable: true,
  },
  {
    headerName: "Contact",
    field: "contact",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Address",
    field: "address",
    tooltipField: "address",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 100,
  },
];

///////*************** */ partner portal *************///////

export const partnerListTable = [
  {
    headerName: "Name",
    valueFormatter: capitalize,
    field: "name",
    tooltipField: "name",
    resizable: true,
    //wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 120,

    // cellRenderer: (params) => <PageLink params={params} />,
  },
  {
    headerName: "Email",
    tooltipField: "email",
    field: "email",
    minWidth: 120,
    resizable: true,
    //wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Contact",
    field: "contact",
    minWidth: 100,
    resizable: true,
    //wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Address",
    field: "address",
    tooltipField: "address",
    minWidth: 100,
    resizable: true,
    //wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "City",
    field: "city",
    minWidth: 100,
    resizable: true,
    //wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "State",
    field: "state",
    minWidth: 100,
    resizable: true,
    //wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Country",
    field: "country",
    minWidth: 100,
    resizable: true,
    //wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Agreement Signed",
    field: "agreement_status",
    valueFormatter: capitalize,
    minWidth: 140,
    resizable: true,
    //wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font ",
  },
  // {
  //   headerName: "Partner Signed Agreement",
  //   field: "partner_signed_agreement",
  //   minWidth: 120,
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  // },
  // {
  //   headerName: "Upload Final Agreement",
  //   field: "upload_final_agreement",
  //   minWidth: 120,
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  // },
  // {
  //   headerName: "Final Agreement",
  //   field: "final_agreement",
  //   minWidth: 120,
  //   resizable: true,
  //   cellStyle: { fontSize: "11px" },
  // },
];

export const commissionListTable = [
  {
    headerName: "Partner",
    valueFormatter: capitalize,
    field: "name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
    // cellRenderer: (params) => <PageLink params={params} />,
  },
  {
    headerName: "Company",
    valueFormatter: capitalize,
    field: "company_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
  },
  {
    headerName: "Cloud Sales",
    field: "cloud_sales",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    valueFormatter: formatCurrency,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
    tooltipField: "email",
  },
  {
    headerName: "Services Sales",
    field: "services_sales",
    valueFormatter: formatCurrency,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    valueFormatter: formatCurrency,
    autoHeight: true,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
  },
  {
    headerName: "Total Commission",
    field: "total_commission",
    minWidth: 100,
    valueFormatter: formatCurrency,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
  },
  {
    headerName: "Deal Value Closed",
    field: "deal_value_closed",
    valueFormatter: formatCurrency,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
  },
];
export const salesListTable = [
  {
    headerName: "Name",
    valueFormatter: capitalize,
    field: "name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 100,
    // cellRenderer: (params) => <PageLink params={params} />,
  },
  {
    headerName: "Address",
    field: "address",
    tooltipField: "address",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Company Name",
    valueFormatter: capitalize,
    field: "company_name",
    tooltipField: "company_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
  },
  {
    headerName: "Project Name",
    valueFormatter: capitalize,
    field: "project_name",
    tooltipField: "project_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
  },
  {
    headerName: "Linkedin URL",
    field: "linkedin_url",
    minWidth: 200,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    tooltipField: "email",
  },
  {
    headerName: "Industry",
    field: "industry_display_value",
    tooltipField: "industry_display_value",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Priority",
    field: "priority",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
    minWidth: 70,
  },
  {
    headerName: "Contact",
    field: "contact",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
    minWidth: 100,
  },
  {
    headerName: "Probability",
    field: "probability",
    minWidth: 90,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
  },
  {
    headerName: "Estimated Close Date",
    field: "estimated_close_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right ",
    headerClass: "justify-right text-right",
  },
];
export const crmLeadsListTable = [
  {
    headerName: "Lead Id",
    field: "lead_code",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize justify-right",
    headerClass: "justify-right",
    minWidth: 120,
  },
  {
    headerName: "Company Name",
    valueFormatter: capitalize,
    field: "company_name",
    tooltipField: "company_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 125,
  },
  {
    headerName: "Project Name",
    valueFormatter: capitalize,
    field: "project_name",
    tooltipField: "project_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 120,
  },
  // {
  //   headerName: "Linkedin URL",
  //   field: "linkedin_url",
  //   minWidth: 200,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   tooltipField: "email",
  // },
  {
    headerName: "Customer Contact",
    field: "cloud_rep",
    tooltipField: "cloud_rep",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 140,
  },
  {
    headerName: "Sales Rep",
    field: "sales_rep",
    tooltipField: "sales_rep",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 140,
  },
  {
    headerName: "Industry",
    field: "industry_display_value",
    tooltipField: "industry_display_value",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Priority",
    field: "priority",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
    minWidth: 70,
  },
  {
    headerName: "Stage",
    field: "stage_display",
    tooltipField: "stage_display",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 70,
  },
  {
    headerName: "Designation",
    field: "designation",
    tooltipField: "designation",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  // {
  //   headerName: "Email",
  //   field: "email",
  //   tooltipField: "email",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  //   minWidth: 150,
  //   // cellRenderer: (params) => <PageLink params={params} />,
  // },
  // {
  //   headerName: "Country Code",
  //   field: "country_code",
  //   minWidth: 120,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalize justify-right",
  //   headerClass: "justify-right",
  // },
  // {
  //   headerName: "State",
  //   field: "state",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalize",
  // },
  // {
  //   headerName: "City",
  //   field: "city",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalize",
  // },

  // {
  //   headerName: "Contact",
  //   field: "contact",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font justify-right",
  //   headerClass: "justify-right",
  //   minWidth: 90,
  // },
  // {
  //   headerName: "Probability",
  //   field: "probability",
  //   minWidth: 90,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font justify-right",
  //   headerClass: "justify-right",
  // },
  {
    headerName: "Estimated Close Date",
    field: "estimated_close_date",
    valueFormatter: formatUSDate,
    minWidth: 160,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right text-right",
  },
  // {
  //   headerName: "Source",
  //   field: "source",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font",
  //   minWidth: 80,
  // },

  // {
  //   headerName: "ARR",
  //   field: "arr",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font justify-right",
  //   headerClass: "justify-right",
  //   minWidth: 70,
  // },

  // {
  //   headerName: "Success Factor",
  //   field: "success_factor",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font",
  //   minWidth: 120,
  // },
  // {
  //   headerName: "Vendor",
  //   field: "vendor",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font",
  //   minWidth: 100,
  // },
  // {
  //   headerName: "Cloud Rev",
  //   field: "cloud_rev",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font justify-right",
  //   headerClass: "justify-right",
  //   minWidth: 85,
  // },
  // {
  //   headerName: "Sales Rev",
  //   field: "sales_rev",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font justify-right",
  //   headerClass: "justify-right",
  //   minWidth: 80,
  // },
  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    minWidth: 105,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right text-right",
  },
];

export const followUpListTable = [
  {
    headerName: "Activity",
    field: "activity",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
  },
  {
    headerName: "Description",
    field: "description",
    tooltipField: "description",

    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
  },
  {
    headerName: "Follow Up Date",
    field: "follow_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    minWidth: 110,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right text-right",
  },
];
export const notesListTable = [
  {
    headerName: "Activity",
    field: "activity",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 100,
  },
  {
    headerName: "Description",
    field: "note_description",
    tooltipField: "note_description",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
  },
  {
    headerName: "Note Date",
    field: "note_date",
    valueFormatter: formatUSDate,
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
];
export const contactsListTable = [
  {
    headerName: "First Name",
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Last Name",
    field: "lastname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    valueFormatter: capitalize,
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Contact",
    field: "contact",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "Address",
    field: "address",
    tooltipField: "address",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
  {
    headerName: "Designation ",
    field: "designation",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Linked in URL ",
    field: "linkedin_url",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },

  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right text-right",
    minWidth: 110,
  },
];
export const cloudRepListTable = [
  {
    headerName: "Name",
    valueFormatter: capitalize,
    field: "name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 120,
    // cellRenderer: (params) => <PageLink params={params} />,
  },

  {
    headerName: "Country Code",
    field: "country_code",
    minWidth: 120,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize justify-right",
    headerClass: "justify-right",
  },
  {
    headerName: "State",
    field: "state",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "City",
    field: "city",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Contact",
    field: "contact",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font justify-right",
    headerClass: "justify-right",
    minWidth: 100,
  },
  {
    headerName: "Linkedin URL",
    field: "linkedin_url",
    minWidth: 200,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    tooltipField: "linkedin_url",
  },
  {
    headerName: "Address",
    field: "address",
    tooltipField: "address",
    minWidth: 200,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalize",
  },
];
export const ChartTable = [
  { headerName: "Assignee", field: "firstname", minWidth: 150 },
  {
    headerName: "Work Distribution",
    field: "percent",
    minWidth: 300,
    cellRenderer: "percentCellRenderer",
    // cellStyle: { background: "grey", color: "white" },
    headerClass: "justify-center",
    cellClass: "pmt-ag-cell-font justify-center",
  },
  {
    headerName: "Count",
    field: "activities_per_user",
    minWidth: 80,
    headerClass: "justify-right",
    cellClass: "pmt-ag-cell-font justify-right",
  },
];
export const ticketViewersTable = [
  {
    headerName: "First Name",
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Last Name",
    valueFormatter: capitalize,
    field: "lastname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    cellClass: "pmt-ag-cell-font capitalizeNone",
    autoHeight: true,
    wrapText: true,
    resizable: true,
  },
];
//project's attachment table
export const projectAttachmentTable = [
  {
    headerName: "Mime Type",
    field: "mime_type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  // {
  //   headerName: "File Name",
  //   field: "file_name",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font",
  // },

  {
    headerName: "Description",
    field: "description",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Created By",
    field: "created_by",
    tooltipField: "created_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right text-right",
    minWidth: 110,
  },
];
//Attendance table

export const AttendanceTable = [
  {
    headerName: "Employee Name",
    field: "emp_name",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Employee Email",
    field: "emp_email",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Status",
    field: "status",
    tooltipField: "created_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Clock In Time",
    field: "clock_in_time",
    valueFormatter: formattedDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 110,
  },
];
export const crmEmailsTable = [
  {
    headerName: "Email By",
    field: "email_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },

  {
    headerName: "Email Discussion",
    field: "email_discussion",
    tooltipField: "created_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Email Date",
    field: "email_date",
    valueFormatter: formattedDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 110,
  },
];
export const crmCallsTable = [
  {
    headerName: "Call By",
    field: "call_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },

  {
    headerName: "Call Discussion",
    field: "call_discussion",
    tooltipField: "created_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Call Date",
    field: "call_date",
    valueFormatter: formattedDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 110,
  },
];
export const crmLinkedInTable = [
  {
    headerName: "Chat By",
    field: "chat_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },

  {
    headerName: "Chat Discussion",
    field: "chat_discussion",
    tooltipField: "created_by",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Chat Date",
    field: "chat_date",
    valueFormatter: formattedDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 110,
  },
];

export const trialUsersTable = [
  {
    headerName: "First Name",
    field: "firstname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: { fontSize: "11px", color: "#007bff", lineHeight: "18px" },
    minWidth: 80,
    maxWidth: 100,
    cellRenderer: (param) => (
      <PageLink params={{ ...param, value: capitalize(param) }} />
    ),
  },
  {
    headerName: "Last Name",
    field: "lastname",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    valueFormatter: capitalize,
    minWidth: 80,
    maxWidth: 100,
  },
  {
    headerName: "Email",
    field: "email",
    tooltipField: "email",
    minWidth: 120,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },

  {
    headerName: "Address",
    field: "address",
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalize",
    minWidth: 100,
    maxWidth: 150,
  },
  {
    headerName: "Contact",
    field: "contact",
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 150,
  },
  {
    headerName: "Company",
    field: "company",
    resizable: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    minWidth: 150,
  },
  {
    headerName: "Created At",
    field: "creation_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
    headerClass: "justify-right",
    minWidth: 90,
    maxWidth: 100,
  },
];
//Leave Management

export const leaveTable = [
  {
    headerName: "Type of Leave",
    field: "type_of_leave",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Reason of Leave",
    field: "reason_of_leave",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Start Date",
    field: "start_date",
    valueFormatter: formatUSDate,
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "End Date",
    field: "end_date",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 150,
  },
  { headerName: "Status", field: "status", resizable: true, minWidth: 150 },
  { headerName: "Day Off", field: "day_off", resizable: true, minWidth: 150 },
];

export const teamLeaveTable = [
  {
    headerName: "Name",
    field: "firstname",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "Email",
    field: "email_id",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Type of Leave",
    field: "type_of_leave",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Reason of Leave",
    field: "reason_of_leave",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Start Date",
    field: "start_date",
    valueFormatter: formatUSDate,
    resizable: true,
    minWidth: 100,
  },
  {
    headerName: "End Date",
    field: "end_date",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 100,
  },
  { headerName: "Status", field: "status", resizable: true, minWidth: 100 },
  { headerName: "Day Off", field: "day_off", resizable: true, minWidth: 100 },
  {
    headerName: "Created Date",
    field: "created_date",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 150,
  },
];

export const CalenderTable = [
  {
    headerName: "Occasion",
    field: "occasion",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Date Of Holiday",
    field: "date_of_holiday",
    valueFormatter: formatUSDate,
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Day",
    field: "holiday_day",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Type",
    field: "holiday_type",
    resizable: true,
    minWidth: 150,
  },
];
export const employeeDocumentTable = [
  {
    headerName: "Document Type",
    field: "document_type",
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
  },
  // {
  //   headerName: "Filename",
  //   field: "file_name",
  //   tooltipField: "file_name",
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font",
  // },
  {
    headerName: "Created Date",
    field: "created_date",
    valueFormatter: formatUSDate,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font",
    minWidth: 110,
  },
];

///resignation///

export const resignationRequestTable = [
  {
    headerName: "Employee Name",
    field: "employee_name",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Status",
    field: "statusdetails",
    resizable: true,
    minWidth: 190,
    cellRenderer: (params) => {
      return params?.data?.statusdetails
        ? params?.data?.statusdetails?.replace("_", "  ")
        : params?.data?.statusdetails?.replace("", "N/A");
    },
    // cellRenderer: (param) => {
    //   const currentStatus = param?.data?.current_status;
    //   if (currentStatus === false) {
    //     return <span>Retain</span>;
    //   } else if (currentStatus === true) {
    //     return <span>Accept</span>;
    //   } else {
    //     return <span>Pending</span>;
    //   }
    // },
  },
  // {
  //   headerName: "Email",
  //   field: "email",
  //   resizable: true,
  //   minWidth: 190,
  // },
  {
    headerName: "Designation",
    field: "designation",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Last Working Day",
    field: "last_working_day",
    resizable: true,
    minWidth: 150,
  },
  // {
  //   headerName: "Resignation Reason ",
  //   field: "resignation_reason",
  //   tooltipField: "resignation_reason",
  //   resizable: true,
  //   minWidth: 150,
  // },
  {
    headerName: "Notice Period (days)",
    field: "notice_period_in_days",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Created Date",
    field: "created_date",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 120,
  },
  {
    headerName: "Employee Remarks",
    field: "employee_remarks",
    tooltipField: "employee_remarks",
    resizable: true,
    //     autoHeight:true,
    // wrapText:true,
    minWidth: 150,
  },
  {
    headerName: "HR Remarks",
    field: "hr_remarks",
    tooltipField: "hr_remarks",
    // autoHeight:true,
    // wrapText:true,
    resizable: true,
    minWidth: 150,
  },
];
export const resignationChecklistTable = [
  {
    headerName: "Employee Name",
    field: "emp_name",
    resizable: true,
    minWidth: 100,
  },

  // {
  //   headerName: "Email",
  //   field: "email",
  //   resizable: true,
  //   minWidth: 190,
  // },

  {
    headerName: "Last Working Day",
    field: "last_working_day",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 150,
  },
  {
    headerName: "Reporting Manager",
    field: "reporting_manager",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Notice Period",
    field: "notice_period",
    resizable: true,
    minWidth: 120,
  },
  {
    headerName: "Status",
    field: "latest_status_details",
    resizable: true,
    minWidth: 140,
    // cellRenderer: (param) => {
    //   const currentStatus = param?.data?.current_status;
    //   if (currentStatus === false) {
    //     return <span>Retain</span>;
    //   } else if (currentStatus === true) {
    //     return <span>Accept</span>;
    //   } else {
    //     return <span>Pending</span>;
    //   }
    // },
  },

  {
    headerName: "Created Date",
    field: "resign_date",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 150,
  },
];

//asssssetss
export const AssetsChecklistTable = [
  {
    headerName: "Employee Name",
    field: "emp_name",
    resizable: true,
    minWidth: 130,
  },
  {
    headerName: "Email",
    field: "employee_email",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "Reporting Manager",
    field: "reporting_manager",
    resizable: true,
    minWidth: 150,
  },
  {
    headerName: "Last Working Day",
    field: "last_working_day",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 150,
  },

  {
    headerName: "Notice Period",
    field: "notice_period",
    resizable: true,
    minWidth: 90,
  },
  {
    headerName: "Status",
    field: "latest_status_details",
    resizable: true,
    minWidth: 290,
    // cellRenderer: (param) => {
    //   const currentStatus = param?.data?.current_status;
    //   if (currentStatus === false) {
    //     return <span>Retain</span>;
    //   } else if (currentStatus === true) {
    //     return <span>Accept</span>;
    //   } else {
    //     return <span>Pending</span>;
    //   }
    // },
  },
  {
    headerName: "Resignation Reason ",
    field: "resignation_reason",
    tooltipField: "resignation_reason",
    resizable: true,
    minWidth: 150,
  },
  // {
  //   headerName: "Employee Remarks",
  //   field: "employee_remarks",
  //   tooltipField: "employee_remarks",
  //   resizable: true,
  //   minWidth: 150,
  // },
  // {
  //   headerName: "HR Remarks",
  //   field: "hr_remarks",
  //   tooltipField: "hr_remarks",
  //   resizable: true,
  //   minWidth: 100,
  // },

  {
    headerName: "Resign Date",
    field: "resign_date",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 150,
  },
];

export const assetAssignedTable = [
  {
    headerName: "Assignee Name",
    field: "assigneename",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Assignee Email",
    field: "assigneeemail",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Assigned Date",
    field: "assigndate",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
    valueFormatter: formatUSDate,
  },
  {
    headerName: "Released Date",
    field: "releaseddate",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
    valueFormatter: function (params) {
      if (!params?.data?.released_by) {
        return "";
      } else {
        return formatUSDate(params);
      }
    },
  },
  {
    headerName: "Assigned By",
    field: "assigned_by",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Released By",
    field: "released_by",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
];

export const fnfProcessChecklistTable = [
  {
    headerName: "Employee Name",
    field: "emp_name",
    resizable: true,
    minWidth: 150,
  },

  {
    headerName: "Email",
    field: "employee_email",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "Reporting Manager",
    field: "reporting_manager",
    resizable: true,
    minWidth: 190,
  },
  {
    headerName: "Last Working Day",
    field: "last_working_day",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 130,
  },
  {
    headerName: "Resign Date",
    field: "resign_date",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 120,
  },

  {
    headerName: "Notice Period",
    field: "notice_period",
    resizable: true,
    minWidth: 100,
  },
  {
    headerName: "Status",
    field: "latest_status_details",
    resizable: true,
    minWidth: 140,
    // cellRenderer: (param) => {
    //   const currentStatus = param?.data?.current_status;
    //   if (currentStatus === false) {
    //     return <span>Retain</span>;
    //   } else if (currentStatus === true) {
    //     return <span>Accept</span>;
    //   } else {
    //     return <span>Pending</span>;
    //   }
    // },
  },

  {
    headerName: "Created Date",
    field: "resign_date",
    resizable: true,
    valueFormatter: formatUSDate,
    minWidth: 150,
  },
];

export const PayslipTable = [
  {
    headerName: "Employee Code",
    field: "employee_code",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Employee Name",
    field: "employee_name",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Pay Period",
    field: "pay_period",
    minWidth: 50,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  //   {
  //     headerName: "Validation Status",
  //     field: "validation_status",
  //     autoHeight: false,
  //     minWidth: 150,
  //     resizable: true,
  //     cellClass: "pmt-ag-cell-font",
  // },
  {
    headerName: "Created By",
    field: "created_by",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Created Date",
    field: "created_date",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
    // valueFormatter: formatUSDate,
  },
  {
    headerName: "Updated By",
    field: "updated_by",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Updated Date",
    field: "updated_date",
    autoHeight: true,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
    // valueFormatter: formatUSDate,
  },
];

// const LargeTextEditor = ({ value, onCellValueChange }) => {
//   const [text, setText] = useState(value);

//   const handleChange = (event) => {
//     const newValue = event.target.value;
//     setText(newValue);
//     onCellValueChange(newValue);
//   };}

export const KRATable = [
  {
    headerName: "Created By",
    field: "created_by",
    minWidth: 50,
    maxWidth: 180,
    resizable: true,
    cellClass: "kra-ag-cell-font",
  },
  {
    headerName: "Created On",
    field: "created_on",
    minWidth: 50,
    maxWidth: 120,
    resizable: true,
    cellClass: "kra-ag-cell-font",
    valueFormatter: formatUSDate,
  },
];

export const appraisalTable = [
  {
    headerName: "Appraisal Status",
    field: "appraisal_status",
    minWidth: 180,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "Appraisal-ag-cell capitalizeNone",
    cellRenderer: (params) => {
      return params?.data?.appraisal_status
        ? params?.data?.appraisal_status?.replace("_", " ")
        : params?.data?.appraisal_status?.replace("", "N/A");
    },
  },
  {
    headerName: "Employee Name",
    field: "emp_name",
    minWidth: 130,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Email",
    field: "emp_email",
    minWidth: 170,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Role",
    field: "role",
    maxWidth: 130,
    minWidth: 70,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Reporting Manager",
    field: "reportingmanager",
    minWidth: 190,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },

  {
    headerName: "Department",
    field: "department",
    minWidth: 70,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  {
    headerName: "Job Title",
    field: "job_title",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    cellClass: "pmt-ag-cell-font capitalizeNone",
    cellRenderer: (params) => {
      return params?.data?.job_title ? params?.data?.job_title : "N/A";
    },
  },
  {
    headerName: "Joining Date",
    field: "joining_date",
    minWidth: 100,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    valueFormatter: formatUSDate,
    cellClass: "pmt-ag-cell-font capitalizeNone",
  },
  // {
  //   headerName: "Employee Status",
  //   field: "employment_status",
  //   minWidth: 100,
  //   resizable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   cellClass: "pmt-ag-cell-font capitalizeNone",
  // },
];
export const meetingsTable = [
  {
    headerName: "Title",
    field: "subject",
    autoHeight: true,
    resizable: true,
    wrapText: true,
    cellClass: "Appraisal-ag-cell capitalizeNone",
    minWidth: 300,
    maxWidth: 350,
  },
  {
    headerName: "status",
    field: "appraisal_status",
    wrapText: true,
    autoHeight: true,
    resizable: true,
    minWidth: 150,
    maxWidth: 250,
    cellClass: "pmt-ag-cell-font",
    cellRenderer: (params) => {
      return params?.data?.appraisal_status
        ? params?.data?.appraisal_status?.replace("_", " ")
        : params?.data?.appraisal_status?.replace("", "N/A");
    },
  },
  {
    headerName: "Start Time",
    field: "meeting_start",
    valueFormatter: formattedDate,
    autoHeight: true,
    maxWidth: 200,
    minWidth: 140,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
    // cellRenderer:(params)=>{

    //   return(
    //      params?.data?.meeting_start.replace("T"," ")
    //   )
    // }
  },
  {
    headerName: "End Time",
    field: "meeting_end",
    valueFormatter: formattedDate,
    maxWidth: 200,
    minWidth: 140,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
    // cellRenderer:(params)=>createDateAsUTC(params?.data?.meeting_end)
  },
  // {
  //   headerName: "Join URL",
  //   field: "link",
  //   cellRenderer: renderLink,
  //   autoHeight: true,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font",
  // },
  {
    headerName: "Organizer",
    field: "scheduled_by",
    autoHeight: true,
    maxWidth: 200,
    minWidth: 170,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Attendees",
    field: "attendees",
    autoHeight: true,
    maxWidth: 450,
    minWidth: 320,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
];
export const EmployeeKRATable = [
  {
    headerName: "Goal",
    field: "kpi_goal",
    resizable: true,
    wrapText: true,
    autoHeight: true,
  },
  {
    headerName: "Employee Rating",
    field: "",
    minWidth: 50,
    maxWidth: 150,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Employee Remarks",
    field: "",
    minWidth: 50,
    maxWidth: 150,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Manager Rating",
    field: "",
    minWidth: 50,
    maxWidth: 150,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Manager Remarks",
    field: "",
    minWidth: 50,
    maxWidth: 150,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  // {
  //   headerName: "Created By",
  //   field: "created_by",
  //   minWidth: 50,
  //   maxWidth: 150,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font",
  // },
  // {
  //   headerName: "Created On",
  //   field: "created_on",
  //   minWidth: 50,
  //   maxWidth: 150,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font",
  //   valueFormatter: formatUSDate,
  // },
];
export const appraisalViewKRATable = [
  {
    headerName: "Goal",
    field: "kpi_goal",
    minWidth: 500,
    maxWidth: 650,
    resizable: true,
    wrapText: true,
    autoHeight: true,
    editable: false,
  },
  {
    headerName: "Employee Remarks",
    field: "employee_remarks",
    minWidth: 300,
    maxWidth: 400,
    resizable: true,
    autoHeight: true,
    wrapText: true,
    editable: false,
    // cellClass: "pmt-ag-cell-font",
  },

  {
    headerName: "Emp Rating",
    field: "employee_rating",
    minWidth: 120,
    maxWidth: 200,
    resizable: true,
    editable: false,
    // cellClass: "pmt-ag-cell-font",
  },

  // {
  //   headerName: "Created By",
  //   field: "created_by",
  //   minWidth: 50,
  //   maxWidth: 150,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font",
  // },
  // {
  //   headerName: "Created On",
  //   field: "created_on",
  //   minWidth: 50,
  //   maxWidth: 150,
  //   resizable: true,
  //   cellClass: "pmt-ag-cell-font",
  //   valueFormatter: formatUSDate,
  // },
];
export const AppraisalTable = [
  {
    headerName: "Goal",
    field: "kpi_goal",
    resizable: true,
    cellEditor: "agLargeTextCellEditor",
    cellEditorPopup: true,
    cellEditorParams: {
      rows: 15,
      cols: 50,
      editable: true,
    },
    //   getRowHeight: (params) => {
    //     const lineHeight = 20;
    //     const defaultHeight = 50;
    //     const field = params.KraList.field || '';
    //     const numLines = Math.ceil(field.length / 50);
    //     return defaultHeight + numLines * lineHeight;
    // }
  },

  {
    headerName: "Remakrs",
    field: "emp_remarks",
    minWidth: 50,
    maxWidth: 150,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
  },
  {
    headerName: "Rating",
    field: "emp_rating",
    minWidth: 50,
    maxWidth: 150,
    resizable: true,
    cellClass: "pmt-ag-cell-font",
    valueFormatter: formatUSDate,
  },
];
